import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import OutlineVerticalAlignBottom from 'react-md-icon/dist/OutlineVerticalAlignBottom';

import './DownloadButton.scss';

const DownloadButton = ({
  downloadAction,
  classes,
  color,
  hidden,
  isDisabled,
}) => (
  <Button
    color={color}
    className={`${classes.join(' ')} ${isDisabled ? 'btn-download-disabled' : ''}`}
    onClick={(e) => {
      e.stopPropagation();
      // using disabled={isDisabled} will prevent the hover effect AND the stopPorpogation,
      // both of which we want, so instead we can just disable the onClick
      if (!isDisabled) downloadAction();
    }}
    hidden={hidden}
    // disabled={isDisabled}
  >
    <OutlineVerticalAlignBottom style={{ fontSize: '1.5rem', lineHeight: 1 }} />
  </Button>
);

DownloadButton.defaultProps = {
  classes: [],
  color: '',
  hidden: false,
  isDisabled: false,
};

DownloadButton.propTypes = {
  downloadAction: PropTypes.func.isRequired,
  classes: PropTypes.arrayOf(PropTypes.string),
  color: PropTypes.string,
  hidden: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default DownloadButton;



// WEBPACK FOOTER //
// ./src/components/DownloadButton/DownloadButton.jsx